import { Bar, mixins } from 'vue-chartjs'
import * as ChartJsPluginDataLabels from 'chartjs-plugin-datalabels'
const { reactiveProp } = mixins
export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: ['options', 'styles'],
  mounted () {
    this.addPlugin(ChartJsPluginDataLabels)
    this.renderChart(this.chartData, this.options)
  }
}
